import type { SxProps, Theme } from "@mui/material"

/**
 * Compose a theme-aware base style with an optional consumer `sx` prop.
 * Prefer this over spreading `sx(theme)` which breaks MUI `SxProps` typing.
 */
export function composeSx(
  base: (theme: Theme) => object,
  sx?: SxProps<Theme>,
): SxProps<Theme> {
  return [base, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]
}
